import React from 'react';
import { ScrollArea, ScrollBar } from './ui/scroll-area';
import { PipelineNode } from './PipelineNode';
import { lanes, tiles } from '../data/pipelineData';

export const SwimlaneDiagram = ({ 
  showTooltips = false, 
  viewMode = 'broken',
  runtimeMode = 'code-change',
  showChickenEggBracket = false,
  draggable = false
}) => {
  const getTileState = (tile, viewMode) => {
    if (viewMode === 'ideal') {
      return { ...tile, state: 'healthy' };
    }
    return tile;
  };

  const isDimmed = (tile, viewMode, runtimeMode) => {
    if (viewMode === 'initial-launch' && tile.firstLaunch === 'dimmed') return true;
    if (viewMode === 'runtime') {
      if (runtimeMode === 'code-change' && tile.runtimeCode === 'dimmed') return true;
      if (runtimeMode === 'new-service' && tile.runtimeNew === 'dimmed') return true;
    }
    return false;
  };

  return (
    <div className="w-full" data-testid="swimlane-diagram">
      <ScrollArea className="w-full whitespace-nowrap">
        <div className="min-w-max">
          {lanes.map((lane) => {
            const laneTiles = tiles
              .filter(t => t.lane === lane.id)
              .sort((a, b) => a.idx - b.idx);

            return (
              <div
                key={lane.id}
                data-testid={`swimlane-${lane.id}`}
                className="flex items-stretch border-b border-[#E2E8F0] last:border-b-0"
              >
                {/* Lane Label */}
                <div
                  className="flex-shrink-0 w-44 p-4 flex items-center border-r border-[#E2E8F0]"
                  style={{ backgroundColor: lane.bgColor }}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-1 h-10 rounded-full ${lane.style === 'dashed' ? 'border border-dashed border-[#888780]' : ''}`}
                      style={{ backgroundColor: lane.style !== 'dashed' ? lane.color : 'transparent' }}
                    />
                    <span className="font-sans font-semibold text-[#1A3A5C] text-sm">
                      {lane.name}
                    </span>
                  </div>
                </div>

                {/* Lane Content - Nodes */}
                <div
                  className="flex-1 flex items-center gap-3 p-4 min-h-[100px] relative"
                  style={{ backgroundColor: lane.bgColor }}
                  data-lane={lane.id}
                >
                  {/* Chicken-egg bracket for GitLab CI/CD lane */}
                  {showChickenEggBracket && lane.id === 'gitlab' && (
                    <div className="absolute top-1 left-[180px] w-[280px] h-1.5 border-t-2 border-l-2 border-r-2 border-dashed border-[#FCA311] flex items-end justify-center z-10">
                      <span className="absolute -bottom-4 bg-white px-2 text-[9px] font-bold text-[#FCA311] whitespace-nowrap">
                        Values chicken-and-egg loop
                      </span>
                    </div>
                  )}
                  
                  {laneTiles.map((tile) => {
                    const displayTile = getTileState(tile, viewMode);
                    const tileDimmed = isDimmed(tile, viewMode, runtimeMode);
                    return (
                      <PipelineNode
                        key={tile.id}
                        tile={displayTile}
                        showTooltip={showTooltips}
                        isDimmed={tileDimmed}
                        showBadge={true}
                        draggable={draggable}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
};

export default SwimlaneDiagram;
